import { View, ActionIcon, Text, Button } from '@/components'
import { theme } from '@/config'
import { createStyles } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'
import { ChatChannel } from '@packages/chat'

type ModalProps = {
  visible: boolean
  toggle: () => void
  request?: {
    resolve: (result: ChatChannel) => void
    reject: (reason: any) => void
  }
}

export type ModalPageProps = Partial<ModalProps> & {
  canGoBack?: boolean
  title: string
  closable?: boolean
  action?: string | null
  buttonProps?: Partial<PropsOf<typeof Button>>
  actionProps?: Partial<PropsOf<typeof ActionIcon>>
  children?: React.ReactNode
  onNextPage?: () => void
  onPrevPage?: () => void
}

export const ModalPageHeader = 60

export const ModalPage = ({
  canGoBack,
  title,
  closable,
  onNextPage,
  onPrevPage,
  toggle,
  buttonProps,
  actionProps,
  children,
}: ModalPageProps) => {
  return (
    <View style={['column']}>
      <View style={styles.header} >
        {canGoBack && (
          <ActionIcon icon='chevron-left' onPress={onPrevPage} style={['minimal', 'normalize']} />
        )}

        <Text text={title} style={['semiBold', { color: theme.colors.textHeadingHighlighted }]} />

        {!!closable && (
          <ActionIcon icon='x' onPress={toggle} style={['minimal']} />
        )}

        {!!actionProps && (
          <ActionIcon
            debugName={'ModalPage:Action'}
            style={['normalize', 'iconSize:2', 'minimal']}
            {...actionProps}
          />
        )}

        {!!buttonProps && (
          <Button debugName='ModalPage:Action' {...buttonProps} onPress={buttonProps?.onPress || onNextPage} style={['minimal']} />
        )}

        {(canGoBack && !closable && !actionProps && !buttonProps) && <View />}
      </View>

      {children}
    </View>
  )
}

const styles = createStyles(theme => ({
  header: {
    ...theme.presets.alignCenter,
    ...theme.presets.justifySpaceBetween,
    ...theme.spacing.paddingHorizontal(3),
    ...theme.spacing.marginVertical(3),
    ...theme.spacing.marginBottom(2),
    maxHeight: theme.size.medium,
  },
}))
